<template>
	<div>
		<div class="special-l">
			<div class="special-title show-one-lines" v-text="param.title"></div>
			<div class="special-b d-flex flex_1">
				<template v-if="param.open_type == 'url'">
					<a :href="param.page_url" target="_blank" class="special-b-img"><img :src="param.pic_url" alt /></a>
				</template>
				<template v-else>
					<router-link :to="param.page_url" class="special-b-img"><img :src="param.pic_url" alt /></router-link>
				</template>
				<div class="special-list d-flex flex-wrap flex_1">
					<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" v-for="(item,index) in param.list[0].goods_list" :key="index">
						<div class="special-item d-flex flex-direction-column align-items-center">
							<img class="special-item-img" :src="item.pic_url" alt />
							<div class="name show-two-lines" v-text="item.name"></div>
							<div v-text="'¥'+item.price"></div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.special-l {
		width: 790px;
		height: 417px;
		margin-top: 20px;
		background-color: #fff;
		padding: 0 20px 20px 20px;
		box-sizing: border-box;

		.special-title {
			line-height: 58px;
			height: 58px;
			font-size: 18px;
			font-weight: 600;
		}

		.special-b {
			.special-b-img {
				height: 339px;
				width: 250px;
				overflow: hidden;

				img {
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
				}

				&:hover img {
					-webkit-transform: scale(1.2);
					-moz-transform: scale(1.2);
					-o-transform: scale(1.2);
					-ms-transform: scale(1.2);
					transform: scale(1.2);
				}
			}

			.special-list {
				.special-item {
					margin-left: 22px;
					&:hover {
						opacity: 0.8;
					}

					&:hover .name {
						color: #c81623;
					}

					.special-item-img {
						height: 80px;
						width: 80px;
					}

					.name {
						width: 143px;
						margin-top: 15px;
						overflow: hidden;
						height: 32px;
						line-height: 16px;
						text-align: center;
					}

					:last-child {
						color: #ff0e25;
						margin-top: 10px;
					}
				}
			}
		}
	}
</style>
